import { render } from "./ExamOpcion.vue?vue&type=template&id=69a465e2&scoped=true"
import script from "./ExamOpcion.vue?vue&type=script&lang=js"
export * from "./ExamOpcion.vue?vue&type=script&lang=js"

import "@/assets/css/listaFiltrada.css?vue&type=style&index=0&id=69a465e2&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\kiatros\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69a465e2"]])

export default __exports__